
import { Component, Vue } from "vue-property-decorator";
import ReportBuilder from "../components/reports/ReportBuilder.vue";
import CustomReports from "../components/reports/CustomReports.vue";
import { RootState, FeaturesList } from '@/store/types';
import { namespace, Getter, Action, State } from "vuex-class";
import NavHeader from '@/components/NavHeader.vue';
import { get } from "lodash";
import { CustomReportModal} from "@/store/reports/types";
import { AxiosResponse } from 'axios';
import CustomReportsApi, {CustomReportEnabledResponse } from "@/services/api.customReports.service";

const ReportsStore = namespace("reports");

@Component({
  components: {
    ReportBuilder,
    CustomReports,
    'nav-header': NavHeader,
  }
})
export default class Reports extends Vue {
  @State((state: RootState) => state.featuresList) private featuresList: FeaturesList;

  @ReportsStore.Mutation setCustomReportModalShown: (customReportModal: CustomReportModal) => void;
  readonly customReportRequestStatusSuccessful: number = 200;
  private customReportsEnabled: boolean = false;

  public get insightsEnabled(): boolean{
    if(get(this.featuresList, ["Insights"]) != null){
      return true;
    } 
    else {
      return false;
    }
  }

  private async mounted(){
    let response: AxiosResponse<CustomReportEnabledResponse> = await CustomReportsApi.customReportsEnabled();
    if (response && response.data && response.status === this.customReportRequestStatusSuccessful) {
        this.customReportsEnabled = response.data.customReportingEnabled;
    }
  }

  private setCustomReportModalOpen(): void{
			this.setCustomReportModalShown({shown: true, insightID: 0, isShared: false});		
  }
}
